<template>
  <div class="order">
    <div class="order-top">
      <div class="order-top__name">订单数量</div>
      <div class="order-top-fun">
        <div class="order-top-item">
          <el-select size="mini" placeholder="全部国家"></el-select>
        </div>
        <div class="order-top-item">
          <el-select size="mini" placeholder="全部店铺"></el-select>
        </div>
        <div class="order-top-item">
          <div class="order-top-item__name">订单编号:</div>
          <el-input size="mini" placeholder="请输入"></el-input>
        </div>
        <div class="order-top-item order-top-item--date">
          <div class="order-top-item__name">订单日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="order-top-item">
          <el-input size="mini" placeholder="请输入搜索内容"></el-input>
        </div>
        <div class="order-top__btn">查询</div>
      </div>
    </div>
    <div class="order-table">
      <Table :head="orderTableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { OrderNewModule, OrderSearchData } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'orderQuantity',
  components: {
    Table
  },
  data(){
    return {
      /**搜索数据 */
      searchData: new OrderSearchData(),
      /**订单数量表头 */
      orderTableHead: OrderNewModule.NEWTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.order{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
    &-fun{
      display: flex;
      align-items: center;
    }
    &-item{
      display: flex;
      align-items: center;
      // width: 120px;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 120px;
        }
        .el-input{
          width: 120px;
        }
      }
      &__name{
        border: 1px solid #cecece;
        width: 90px;
        height: 28px;
        line-height: 28px;
        text-align: center;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 200px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 30px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
